import { render, staticRenderFns } from "./AddPatientModal.vue?vue&type=template&id=5b37d746&"
import script from "./AddPatientModal.vue?vue&type=script&lang=js&"
export * from "./AddPatientModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports